<ng-container *ngIf="pageH1Service.heading$ | async as heading">
  <div class="page-h1-wrapper" [class.page-h1-wrapper--home]="pageH1Service.isHomePage$ | async">
    <div class="container page-container">
      <h1 class="sr-page-h1 sr-bold black-text lighten-1">
        {{ heading }}
      </h1>
    </div>
  </div>
</ng-container>
